export default __webpack_public_path__ + "static/media/koordynacja-dnia-slubu.da14627b.md";